import { IToDo, Persona } from '@/@types';

export const toDos: IToDo[] = [
  {
    personas: [
      Persona.Developer,
      Persona.Founder,
      Persona.Maker,
    ],
    completed: false,
    description: 'Play a major role in a company that will affect my grand children, and every one elses for that matter.',
  },
  {
    personas: [
      Persona.Developer,
      Persona.Founder,
      Persona.Maker,
    ],
    completed: false,
    description: 'Rent a scooter in Vietnam and ride along the Ho Chi Minh Trail ala Top Gear.',
  },
  {
    personas: [
      // Persona.Developer,
      Persona.Founder,
      Persona.Maker,
    ],
    completed: false,
    description: 'Be involved with TechStars:Boulder to help good people make good things.',
  },
  // {
  //   personas: [
  //     Persona.Developer,
  //     Persona.Founder,
  //     Persona.Maker,
  //   ],
  //   completed: false,
  //   description: 'Obtain said grandchildren through nature or adoption.',
  // },
  {
    personas: [
      Persona.Developer,
      Persona.Founder,
      Persona.Maker,
    ],
    completed: false,
    description: 'Restore a BMW motorcycle from the 70\'s.',
  },
  {
    personas: [
      Persona.Developer,
      Persona.Founder,
      Persona.Maker,
    ],
    completed: false,
    description: 'Sail from New York City to Anchorage, Alaska.',
  },
  {
    personas: [
      Persona.Developer,
      Persona.Founder,
      Persona.Maker,
    ],
    completed: false,
    description: 'Retire onto a self sustaining ranch off the grid with a bunch of adorable fainting goats.',
  },
];

export default toDos;
